export default function PHP_sqrt() {
  return (
    <div>
      <h1>PHP_sqrt</h1>
    </div>
  );
}
